export const localStorageService = {
  getItem(key) {
    return localStorage.getItem(key);
  },
  setItem(key, value) {
    localStorage.setItem(key, value);
  },
  removeItem(key) {
    localStorage.removeItem(key);
  },

  // Atajo para token
  getToken() {
    return this.getItem('access_token');
  },
  setToken(token) {
    this.setItem('access_token', token);
  },
  removeToken() {
    this.removeItem('access_token');
  },
  getSessionTokenAndId() {
    const token = this.getItem('access_token');
    const id = this.getItem('id');
    return { token, id };
  },
  isSessionActive() {
    const { token, id } = this.getSessionTokenAndId();
    return Boolean(token && id);
  },
  guardarSesion(data) {
    const camposSesion = ['clave', 'id', 'plan_web_pagado', 'tipo', 'username'];
    camposSesion.forEach((k) => this.setItem(k, data[k]));
    this.setToken(data.token);
    this.removeItem('permisos');
  },
  obtenerSesion() {
    const camposSesion = ['clave', 'id', 'plan_web_pagado', 'tipo', 'username'];
    const sesion = {};
    camposSesion.forEach((k) => {
      sesion[k] = this.getItem(k);
    });
    sesion.token = this.getToken();
    return sesion;
  },
  destruirSesion() {
    const camposSesion = [
      'clave',
      'id',
      'plan_web_pagado',
      'tipo',
      'username',
      'access_token',
      'permisos',
    ];
    camposSesion.forEach((k) => this.removeItem(k));
  },
};
